import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-server-unavailable',
  templateUrl: './server-unavailable.component.html',
  styleUrls: ['./server-unavailable.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule]
})
export class ServerUnavailableComponent {

  constructor(
    public _dialogRef: MatDialogRef<ServerUnavailableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) { }

  exit() {
    this._dialogRef.close();
  }

}
